import {Address} from './address.model';
import {DictionaryItem} from './dictionary.model';
import {GenericEntity} from './generic-entity.model';
import {Partner} from './partner.model';
import {LocalizationOperation} from '../enums/operations.enum';

export class Localization extends GenericEntity {
    address: Address = new Address();
    code: string;
    isActive: boolean;
    isInstallments: boolean;
    isOutlet: boolean;
    isPue: boolean;
    isSubscription: boolean;
    nameFull: string;
    nameShort: string;
    partner: Partner;
    region: string;
    sellTypes: DictionaryItem[] = [];
    subRegion: string;
    availableOperations: LocalizationOperation[];

    constructor(props = {}) {
        super(props);
        Object.assign(this, props);
    }

    isOperationEnabled(operation: LocalizationOperation) {
        return this.availableOperations?.includes(operation);
    }
}

export class LocalizationIdentity {
    nameFull: string;
    code: string;
    id: string;
    address: Address;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}
